<div
    class="evidence-playground"
    data-testid="evidence-playground"
    [attr.data-phase]="phase"
    [attr.data-evidence-ready]="evidenceReady ? 'true' : 'false'"
    [attr.data-evidence-row-count]="evidenceRowCount ?? ''"
    [attr.data-evidence-swap-count]="evidenceSwapCount || ''"
>
    <div class="evidence-playground__toolbar">
        <div class="evidence-playground__status">
            <span *ngIf="phase === 'waiting-jwt'">Waiting for session token…</span>
            <span *ngIf="phase === 'waiting-group'">No group context — select an entity in the dashboard first.</span>
            <span *ngIf="phase === 'loading' || phase === 'ready'">
                Group: <strong>{{ boundGroupName || boundGroupId }}</strong>
                <span *ngIf="groupContextChanged" class="evidence-playground__badge">context changed — reloading</span>
                <span *ngIf="evidenceReady && evidenceRowCount !== null" data-testid="evidence-playground-row-count">
                    — {{ evidenceRowCount }} month(s)
                </span>
            </span>
        </div>
        <button
            *ngIf="phase === 'ready' || phase === 'loading'"
            type="button"
            class="btn btn-sm btn-outline-secondary evidence-playground__reload"
            data-testid="evidence-playground-reload"
            (click)="reloadEvidence()"
        >
            Reload report
        </button>
    </div>

    <iframe
        *ngIf="iframeUrl"
        #frame
        class="evidence-playground__frame"
        data-testid="evidence-playground-iframe"
        [src]="iframeUrl"
        (load)="onLoad()"
        title="Evidence.dev playground"
        referrerpolicy="no-referrer"
    ></iframe>
</div>
